import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/UI/Header';
import Footer from '../components/UI/Footer';
import './style.less';

const containerST = {
   backgroundColor: '#444',
   minHeight: '100%',
   position:'relative',
   textAlign: 'center'
};

const TemplateWrapper = ({ children }) => (
  <div style={containerST} className={'bgimg'}>
    <Helmet
      title="MRM Support - AVIS Customer Care"
      meta={[
        { name: 'description', content: 'Sample' },
        { name: 'keywords', content: 'sample, something' },
      ]}
    />
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
        minHeight: '100vh'
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js